import script from "./SafetyEventsInbox.vue?vue&type=script&setup=true&lang=js"
export * from "./SafetyEventsInbox.vue?vue&type=script&setup=true&lang=js"

import "./SafetyEventsInbox.vue?vue&type=style&index=0&id=4bbbaa92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bbbaa92"]])

export default __exports__